// extracted by mini-css-extract-plugin
module.exports = {"button":"ToggleSearch_button__ZmVl0","wrapper":"ToggleSearch_wrapper__cX1Ap","label":"ToggleSearch_label__Ntj7n","loading":"ToggleSearch_loading__Uzclo"};